




import Vue from 'vue'
import Component from 'vue-class-component'

@Component<WordFile>({
  props: {
    color1: {
      type: String,
      default : "#2b579a"
    }
  }
})

export default class WordFile extends Vue {
  /**
   * Props variables
   */
  color1: string | undefined
  color2: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
